// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 1,
  value: "",

  statut: "",

  sortField: "",
  order: "desc",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_CONFIG_MESSAGERIE:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_CONFIG_MESSAGERIE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case actionTypes.SET_STATUT_CONFIG_MESSAGERIE:
      return {
        ...state,
        statut: action.payload,
      };

    case actionTypes.SET_SORT_FIELD_CONFIG_MESSAGERIE:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_ORDER_CONFIG_MESSAGERIE:
      return {
        ...state,
        order: action.payload,
      };

    default:
      return state;
  }
};

export default rootReducer;
